import { render, staticRenderFns } from "./IconFullScreen.vue?vue&type=template&id=0f8f0a3c&scoped=true"
import script from "./IconFullScreen.vue?vue&type=script&lang=js"
export * from "./IconFullScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f0a3c",
  null
  
)

export default component.exports